import api from './client';

export interface Machine {
  id: number;
  name: string;
  type: string;
  department: string;
  status: 'available' | 'in_use' | 'maintenance';
  description: string | null;
  createdAt: string;
  maintenanceHistory?: MaintenanceRecord[];
}

export interface MaintenanceRecord {
  id: number;
  machineId: number;
  performedAt: string;
  type: 'preventivo' | 'correctivo' | 'revision';
  description: string;
  cost: number | null;
  performedBy: string;
  nextMaintenanceDate: string | null;
  createdBy: { id: number; name: string } | null;
  createdAt: string;
}

export interface CreateMachinePayload {
  name: string;
  type: string;
  department: string;
  status?: string;
  description?: string | null;
}

export interface AddMaintenancePayload {
  performedAt?: string;
  type: 'preventivo' | 'correctivo' | 'revision';
  description: string;
  cost?: number | null;
  performedBy: string;
  nextMaintenanceDate?: string | null;
}

export const machinesApi = {
  getMachines: (params?: { department?: string; status?: string }) =>
    api.get('/machines', { params }).then((r) => r.data as { data: Machine[]; total: number }),

  getMachine: (id: number) =>
    api.get(`/machines/${id}`).then((r) => r.data as { data: Machine }),

  createMachine: (payload: CreateMachinePayload) =>
    api.post('/machines', payload).then((r) => r.data as { data: Machine }),

  updateMachine: (id: number, payload: Partial<CreateMachinePayload>) =>
    api.patch(`/machines/${id}`, payload).then((r) => r.data as { data: Machine }),

  updateMachineStatus: (id: number, status: string) =>
    api.patch(`/machines/${id}/status`, { status }).then((r) => r.data as { data: Machine }),

  getMaintenance: (id: number) =>
    api.get(`/machines/${id}/maintenance`).then((r) => r.data as { data: MaintenanceRecord[]; total: number }),

  addMaintenance: (id: number, payload: AddMaintenancePayload) =>
    api.post(`/machines/${id}/maintenance`, payload).then((r) => r.data as { data: MaintenanceRecord }),

  assignMachine: (machineId: number, stepId: number) =>
    api.post(`/machines/${machineId}/assign`, { stepId }).then((r) => r.data),

  releaseMachine: (machineId: number) =>
    api.post(`/machines/${machineId}/release`, {}).then((r) => r.data),
};
